import { render, staticRenderFns } from "./FullPage.vue?vue&type=template&id=315b394a&"
import script from "./FullPage.vue?vue&type=script&lang=ts&"
export * from "./FullPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports